//Componentes generales
import React, { useState, useEffect } from "react";
import UserInfo from "../../components/UserInfo/UserInfo";
import FormUser from "../FormUser/FormUser";
import SearchInput from "../../components/searchInput/SearchInput";
import AddItm from "../addItm/AddItm";
import { FixedSizeList as List } from "react-window";
import RenderRow from "../renderRows/RRUser";

// Estilos
import "./UserList.css";

/* 
    Componente encargado de mostrar listado de usuarios.
        Donde list es el listado de usuarios.
              verModificar es la función del context que oculta el dialog de modificación de usuario.
              estadoVerModificar es la función del context que muestra el dialog de modificación de usuario.
              saveModificacion es la función del context encargada de guardar un usuario nuevo o modificado.
              verUser es la función del context que muestra el dialog de detalle de usuario.
              seleccionado es el usuario seleccionado de la lista.
              eliminarUser es la función del context que elimina un usuario (tiene que cumplir ciertas condiciones).
              verficaCantidadUser es la función del context que controla la cantidad de usuarios habilitados contra la cantidad en su licencia.

*/
function UserList({
  list = [],
  listLoading = true,
  verModificar,
  estadoVerModificar,
  saveModificacion,
  verUser,
  seleccionado,
  eliminarUser,
  verificaCantidadUsers,
  listGroups,
}) {
  //state para mostrar el dialog de información usuario.
  const [showUserInfo, setShowUserInfo] = useState(false);
  //state titulo del dialog a utilizar.
  const [title, setTitle] = useState("");
  //state del filtro por busqueda.
  const [filter, setFilter] = useState("");
  const [cantidadUsuarios, setCantidadUsuarios] = useState({
    loading: true,
    userEnabled: 0,
    maxUsersEnabled: 0,
    totalUsers: 0,
  });

  useEffect(() => {
    const verificar = async () => {
      const licenciaUsuario = await verificaCantidadUsers();
      setCantidadUsuarios(prev => ({
        ...prev,
        loading: false,
        ...licenciaUsuario.data,
      }));
    };
    verificar();
  }, []);

  useEffect(() => {
    setCantidadUsuarios(prev => ({ ...prev, totalUsers: list.length }));
  }, [list]);

  /* 
        Función que determina si mostrar el detalle del usuario seleccionado.
            Donde usuario es el usuario seleccionado de la lista.
    */
  const checkEstadoVisibilidad = (usuario) => {
    verUser(usuario);
    showUserInfo ? setShowUserInfo(false) : setShowUserInfo(true);
  };

  /* 
        Función que determina si mostrar el formulario para editar el usuario seleccionado.
            Donde user es el usuario seleccionado de la lista.
        Se setea el titulo encabezado del formulario.
    */
  const enviarModificar = (user) => {
    setTitle("Modificar Usuario");
    verModificar(user);
  };

  /* 
        Función que determina si mostrar el formulario para agregar un nuevo usuario.
            Donde user es el usuario seleccionado (no esta en uso).
        Se setea el titulo encabezado del formulario.
    */
  const enviarAgregar = (user) => {
    setTitle("Nuevo Usuario");
    verModificar(user);
  };

  /* 
        Función que setea el filtro de busqueda.
            Donde data es lo ingresado por el usuario.
    */
  const handdlerSearchInput = (data) => {
    setFilter(data);
  };

  const filteredList = list.filter(
    (user) =>
      user.fullName.toLowerCase().includes(filter.toLowerCase()) ||
      user.userName.toLowerCase().includes(filter.toLowerCase())
  );

  const isLoading = cantidadUsuarios.loading || listLoading;

  return (
    <div>
      {isLoading && (
        <div className="user-fullscreen-overlay">
          <div className="user-fullscreen-spinner" />
        </div>
      )}

      {!isLoading && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              width: "100%",
              marginTop: "-5px",
            }}
          >
            <div style={{ marginLeft: "77%" }}>
              <AddItm titulo="Nuevo usuario" anadiritm={enviarAgregar} />
            </div>
          </div>

          <div className="container-user-list">
            <div style={{ marginLeft: "-430px" }}>
              {" "}
              <SearchInput defaultValue={filter} buscar={handdlerSearchInput} />
            </div>

            <article>
              <div className="container-list-infoo">
                <div className="container-list-item-infoo">
                  <div className="cant-user">
                    <div className="cant-user-cont1">Cantidad de usuarios</div>
                    <div className="cant-user-img">&#123;</div>
                    <div className="cant-user-cont2">
                      <div className="cant-user-items">
                        Licencia
                        <div className="cant-user-number">
                          {cantidadUsuarios.maxUsersEnabled}
                        </div>
                      </div>
                      <div className="cant-user-items">
                        Habilitados
                        <div className="cant-user-number">
                          {cantidadUsuarios.userEnabled}
                        </div>
                      </div>
                      <div className="cant-user-items">
                        Deshabilitados
                        <div className="cant-user-number">
                          {cantidadUsuarios.totalUsers - cantidadUsuarios.userEnabled}
                        </div>
                      </div>
                    </div>
                    <div className="cant-user-img2">|</div>
                    <div className="cant-user-cont3">
                      {cantidadUsuarios.totalUsers}
                    </div>
                  </div>
                </div>
              </div>
            </article>
            <List
              height={window.innerHeight - 410}
              itemCount={filteredList.length}
              itemSize={180}
              width="99%"
              style={{ marginLeft: "0.5%" }}
              itemData={{
                ...filteredList,
                enviarModificar,
                eliminarUser,
                checkEstadoVisibilidad,
              }}
            >
              {RenderRow}
            </List>
          </div>
          {showUserInfo && (
            <div className="modalUser">
              <UserInfo
                user={seleccionado}
                verCerrarSesion={false}
                mode={checkEstadoVisibilidad}
              />
            </div>
          )}
          {estadoVerModificar && (
            <div className="modalUser">
              <FormUser
                data={seleccionado}
                minimizar={verModificar}
                generar={saveModificacion}
                titulo={title}
                verificaUser={verificaCantidadUsers}
                licenciaUsuarios={verificaCantidadUsers}
                usuariosHabilitados={() => list.filter((d) => d.enabled).length}
                listGroups={listGroups}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default UserList;